import React from 'react'
import { Draggable } from 'react-beautiful-dnd'
import styled from 'styled-components'

import IconButton from 'js/components/IconButton/IconButton'
import { useSubtype } from 'js/lib/hooks/useSubtypes'

import CrossIcon from 'icons/cross.svg'
import MoveIcon from 'icons/move-vertical.svg'

const Wrapper = styled.li`
    display: flex;
    background: white;
    border-bottom: 1px solid transparent;

    &:not(:last-child) {
        border-bottom-color: ${(p) => p.theme.color.grey[20]};
    }

    &[aria-current='dragging'] {
        border-bottom-color: transparent;
        box-shadow: ${(p) => p.theme.shadow.soft.center};
        border-radius: ${(p) => p.theme.radius.small};
    }

    .SearchResultsItemsText {
        margin-right: auto;
        padding: 9px 0;
        line-height: ${(p) => p.theme.font.lineHeight.small};
    }

    .SearchResultsItemsTitle {
        margin-right: 4px;
        font-size: ${(p) => p.theme.font.size.small};
    }

    .SearchResultsItemsSubtype {
        font-size: ${(p) => p.theme.font.size.tiny};
        color: ${(p) => p.theme.color.text.grey};
    }

    .SearchResultsItemsMove {
        display: flex;
        align-items: center;
        height: 40px;
        margin-right: 8px;
    }
`

const InsertFromContentItems = ({ index, entity, onRemove }) => {
    const { guid, title, subtype } = entity

    const { name } = useSubtype(subtype)

    return (
        <Draggable draggableId={guid} index={index}>
            {(provided, snapshot) => (
                <Wrapper
                    ref={provided.innerRef}
                    aria-current={snapshot.isDragging ? 'dragging' : null}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                >
                    <div className="SearchResultsItemsMove">
                        <MoveIcon />
                    </div>
                    <div className="SearchResultsItemsText">
                        <span className="SearchResultsItemsTitle">{title}</span>
                        {name && (
                            <span className="SearchResultsItemsSubtype">
                                {name}
                            </span>
                        )}
                    </div>
                    <IconButton
                        className="SearchResultsItemsRemove"
                        variant="secondary"
                        size="large"
                        onClick={onRemove}
                    >
                        <CrossIcon />
                    </IconButton>
                </Wrapper>
            )}
        </Draggable>
    )
}

export default InsertFromContentItems
